import React from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { decrementProduct, incrementProduct } from '../redux/Products/actions';

const Cart = () => {
    const carts = useSelector((state) => state.cart);
    const dispatch = useDispatch();

    const handleIncrementProduct = (cart) => {
        (dispatch(incrementProduct(cart)))
    }
    const handleDecrementProduct = (cart) => {
        (dispatch(decrementProduct(cart)))
    }

    const totalItem = carts.reduce((acc, product) => {
        return acc + product.quantity;
    }, 0);

    const totalPrice = carts.reduce((acc, product) => {
        return acc + product.price * product.quantity;
    }, 0);

    return (
        <div
            className="col-span-12 sm:col-span-12 md:col-span-5 lg:col-span-4 xxl:col-span-4"
        >
            <div
                className="bg-white py-4 px-4 shadow-md rounded-lg my-4 mx-4"
            >
                {
                    carts.map((cart) => (
                        <div key={cart.id} className="flex justify-between border-b-2 mb-2">
                            <div className="text-lg py-2">
                                <p>{cart.name}</p>
                            </div>
                            <div className="text-lg py-2">
                                <div
                                    className="flex flex-row space-x-2 w-full items-center rounded-lg"
                                >
                                    <button
                                        className="focus:outline-none bg-purple-700 hover:bg-purple-800 text-white font-bold py-1 px-1 rounded-full inline-flex items-center"
                                        onClick={() => handleDecrementProduct(cart)}
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="h-4 w-4"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                        >
                                            <path
                                                strokeLinecap='round'
                                                strokeLinejoin='round'
                                                strokeWidth={2}
                                                d="M18 12H6"
                                            />
                                        </svg>
                                    </button>
                                    <p>{cart.quantity}</p>
                                    <button
                                        className="focus:outline-none bg-purple-700 hover:bg-purple-800 text-white font-bold py-1 px-1 rounded-full inline-flex items-center"
                                        onClick={() => handleIncrementProduct(cart)}
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="h-4 w-4"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                        >
                                            <path
                                                strokeLinecap='round'
                                                strokeLinejoin='round'
                                                strokeWidth={2}
                                                d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                                            />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))
                }

                <div
                    className="flex justify-center items-center text-center"
                >
                    <div className="text-xl font-semibold">
                        <p>Total Item</p>
                        <p className="text-5xl">{totalItem}</p>
                    </div>
                </div>
            </div>
            <div
                className="bg-white py-4 px-4 shadow-md rounded-lg my-4 mx-4"
            >
                <div
                    className="flex justify-center items-center text-center"
                >
                    <div className="text-xl font-semibold">
                        <p>Total Price</p>
                        <p className="text-5xl">Tk. {totalPrice}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Cart;